<template>
  <div data-grid class="notes-list">
    <notesItem :type="type" v-for="(item) in data" :data="item" :key="item.id" @update="done"></notesItem>
  </div>
</template>
<script>
import Bricks from 'bricks.js'
import notesItem from './notesItem'

let instance = null
export default {
  name: 'NotesList',
  props: {
    data: Array,
    type: String,
    columns: { type: Number, default: 4 },
    gutter: { type: Number, default: 21 }
  },
  components: { notesItem },
  mounted() {
    this.$nextTick(() => {
      instance = Bricks({
        container: '[data-grid]',
        packed: 'data-packed',
        sizes: [{ columns: this.columns, gutter: this.gutter }]
      })
      instance.resize(true).pack()
    })
  },
  methods: {
    done() {
      instance && instance.resize(true).pack()
    }
  }
}
</script>
